import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'wct-json',
  standalone: true,
  imports: [JsonPipe],
  templateUrl: './json.component.html',
  styleUrl: './json.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JsonComponent<T> {
  @Input({ required: true }) public value: T;
  @Input({ required: false }) public expanded: boolean = false;

  protected isValue(value: unknown = this.value) {
    return value === null || !(typeof value === 'object' || typeof value === 'function');
  }

  protected isArray(value: unknown = this.value): value is Array<unknown> {
    return Array.isArray(value);
  }

  protected keys(value: unknown = this.value): Array<keyof T> {
    return Object.keys(value) as any;
  }

  protected* getChildren(): Generator<[unknown, unknown], void, unknown> {
    if (this.isArray(this.value)) {
      for (let i = 0; i < this.value.length; i++) {
        yield [i, this.value[i]]
      }
    } else if (this.keys().length > 0) {
      for (const key of this.keys()) {
        yield [key, this.value[key]];
      }
    }
  }
}
